import { Box, Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { GallerySliderProps } from "~/features/gallery-slider/GallerySlider";

type PaginationButtonsProps = GallerySliderProps & {
  activeIndex: number;
};
export const PaginationDots: FC<PaginationButtonsProps> = ({
  data,
  activeIndex,
}) => {
  return (
    <Flex justify="center" gap={8} md={{ gap: 12 }}>
      {(data.pictures ?? data.images)?.map((_, index) => (
        <Box
          as="span"
          key={index}
          d={{ height: 12, width: 12 }}
          md={{ height: 8, width: 8 }}
          width={8}
          height={8}
          border={{ radius: "9999px" }}
          className="transition-all duration-300"
          bg={
            activeIndex === index
              ? "surface-primary-hovered"
              : "surface-neutral-light"
          }
        />
      ))}
    </Flex>
  );
};
